export default {
  init() {
    $(function(){

      if($(".section-vertical-tabs").length){

        try{
          var tab_content_items = $(".section-vertical-tabs .content-inner .tab-content[id]");

          $(".section-vertical-tabs .content-inner").scroll(function(){
          
            try {
              var diff       = false;
              var active_tab = false;

              tab_content_items.each(function(){

                try {
                  var id = $(this).attr('id');
                  var position = $("#" + id).offset().top - $("#" + id).offsetParent().offset().top;
                  var item_diff = 150 - parseInt(position);
                  if(item_diff < 0) item_diff = item_diff * -1;

                  // console.log(id, position, item_diff);

                  if(diff === false || item_diff < diff) {
                    diff = item_diff;
                    active_tab = "#" + id;
                  }
                }
                catch(err){
                  // console.error(err);
                }
              });

              $(".section-vertical-tabs .tabs-col [data-target]").removeClass("active");
              $(".section-vertical-tabs .tabs-col [data-target='" + active_tab + "']").addClass("active");
            }
            catch(err){
              console.error(err);
            }
          });

        }
        catch(err){
          // console.error(err);
        }


        try{
          $(".section-vertical-tabs .tabs-col a[data-target]").click(function(e){
  
            e.preventDefault();
  
            var target = $(this).attr("data-target");
            var inner  = $('.section-vertical-tabs .tabs-container .content-col .content-inner');
           
            inner.animate({
                scrollTop: $(target).position().top + inner.scrollTop() - 100,
            }, 500);
          });
        }
        catch(err){
          // console.log(err);
        }

        try{

          var sticked = false;
  
          $(window).scroll(function(){
  
            if($(window).width() > 738){
              var scroll_top = $(window).scrollTop();
              var window_height = $(window).height();
              var cta_top = $('.section-vertical-tabs .cta-cont')[0].getBoundingClientRect().top;
              var section_bottom = $(".vertical-tabs-bottom")[0].getBoundingClientRect().top;
  
              if(scroll_top < 515) {
                var bottom = parseInt(515 - scroll_top);
                $('.section-vertical-tabs .cta-cont.sticky').css({'bottom' : "-" + bottom + "px"});
              }
  
              else{
                $('.section-vertical-tabs .cta-cont.sticky').css({'bottom' : "0px"});
              }
              
              if(cta_top > window_height - 80 ){
                if(!sticked) {
                  $('.section-vertical-tabs .cta-cont').addClass('sticky');
                  sticked = true;
                }
              }
              else{
                if(sticked && (section_bottom - 80) < window_height) {
                  $('.section-vertical-tabs .cta-cont').removeClass('sticky');
                  sticked = false;
                }
              }
            }
          });
        }
        catch(err){
          // console.error(err);
        }

      }
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/vertical-tabs.js